import { initAuth } from "../../../redux/auth.reducer";
import api from "../../../utils/useApi";
import { STATE_CONSTANTS_ADDRESS } from "../../../utils/useConstantState";
import { FunctionCheckIsBKK } from "../../../utils/useFunction";

//  {
//     owner: String,
//     where: String,
//     lat: Number,
//     lng: Number,
//     title: String,
//     detail: String,
//     type: {
//       type: String,
//       enum: ["HOME", "WORK", "OTHER"],
//     },
//   },

const AddressCreateMyLocation = async (
  name,
  description,
  selectedLocation,
  user,
  refetch,
  isPrimary,
  dispatch,
  setSelectedLocation,
  setState,
  state,
  navigate,
  setAddress,
  setIsStar
) => {
  if (state) {
    return;
  }
  try {
    // setState(true);
    const thisIndex = user?.address?.findIndex(
      (item) => item?.place_id === selectedLocation?.place_id
    );
    const myOwnAddress = thisIndex > -1;

    const thisAddress = myOwnAddress ? user?.address[thisIndex]?._id : null;

    let object = {
      owner: user._id,
      where: selectedLocation?.formatted_address,
      lat: selectedLocation?.lat,
      lng: selectedLocation?.lng,
      title: name,
      detail: description,
      type: "OTHER",
      place_id: selectedLocation?.place_id,
      reference: selectedLocation?.reference,
      primary: !!isPrimary,
      link: selectedLocation?.link,
      location: FunctionCheckIsBKK(selectedLocation?.address_components),
      address_components: selectedLocation?.address_components,
      formatted_address: selectedLocation?.formatted_address,
      name: selectedLocation?.name,
      isAvailable: true,
      name_google: selectedLocation?.name_google,
    };

    // console.log("AddressCreateMyLocation : ", {
    //   selectedLocation,
    //   name,
    //   description,
    //   isPrimary,
    //   user,
    //   object,
    //   myOwnAddress,
    //   thisAddress,
    // });

    if (thisAddress) {
      await api.put(`/address/${thisAddress}`, object);
      refetch();
      dispatch(initAuth());
      // setSelectedLocation(false);
      setAddress(object);
      setIsStar(false);
      navigate("/Basket");
    } else {
      await api.post("/address", object);
      refetch();
      dispatch(initAuth());
      // setSelectedLocation(false);
      setAddress(object);
      setIsStar(false);
      navigate("/Basket");
    }
  } catch (error) {
    console.error("AddressCreateMyLocation error : ", error);
  }
};

export default AddressCreateMyLocation;
